import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, CircularProgress, Alert, IconButton, Grid } from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import StarIcon from '@mui/icons-material/Star';
import CloseIcon from '@mui/icons-material/Close';
import { getMlmorderInfoByPaymentidAPI } from 'components/mlmorder/MlmorderAPI';

const API_BASE = "https://api.dmp.appmachine.in/mlmcredits/paymentid/";

function formatRupees(val) {
    return `₹${Number(val).toFixed(2)}`;
}

export default function MlmcreditListByPaymentId({ paymentId, onClose }) {
    const [loading, setLoading] = useState(false);
    const [creditList, setCreditList] = useState([]);
    const [error, setError] = useState('');
    const [orderObj, setOrderObj] = useState(null);

    const fetchCredits = async (paymentId) => {
        setLoading(true);
        setError('');
        setCreditList([]);
        try {
            const token = localStorage.getItem('JWT');
            const res = await fetch(`${API_BASE}${paymentId}/paymentid`, {
                headers: {
                    'Authorization': token ? `Bearer ${token}` : ''
                }
            });
            const data = await res.json();
            if (data && Array.isArray(data.list)) {
                setCreditList(data.list);
            } else {
                setError('No data found');
            }
        } catch (e) {
            setError('Failed to fetch credits');
        }
        setLoading(false);
    };
    useEffect(() => {
    },[orderObj]    );

    useEffect(() => {
        if (paymentId) {
             getMlmorderInfoByPaymentidAPI(paymentId,()=>{},handleOrderSuccess);
            fetchCredits(paymentId);
        }
    }, [paymentId]);

    const handleOrderSuccess = (data) => {
        setOrderObj(data[0]);
    }

    return (
        <Box sx={{  m: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                    Credit Details
                </Typography>
                {onClose && (
                    <IconButton aria-label="close" onClick={onClose} size="small">
                        <CloseIcon />
                    </IconButton>
                )}
            </Box>
            {loading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                    <CircularProgress />
                </Box>
            )}
            {error && (
                <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
            )}
            <Box sx={{
                maxHeight: 350,
                overflowY: 'auto',
                pr: 1
            }}>
                <Grid container direction="row">

                {creditList && creditList.map(item => (
                    <Grid item lg={4} sm={6} xs={12} key={item.id} sx={{ p: 1 }}>
                        <Card
                            key={item.id}
                            sx={{
                                mb: 2,
                                borderRadius: 3,
                                background: 'linear-gradient(135deg, #e3f2fd 0%, #fff 100%)',
                            }}
                        >
                            <CardContent>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <StarIcon sx={{ color: '#1976d2', fontSize: 22 }} />
                                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#1976d2' }}>
                                            {item.mlmusername}
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                                        Level {item.creditlevel}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                        <MonetizationOnIcon sx={{ color: 'success.main', fontSize: 28 }} />
                                        <Typography variant="h4" sx={{ fontWeight: 700, color: 'success.main' }}>
                                            {formatRupees(item.creditvalue)}
                                        </Typography>
                                    </Box>
                                    <Typography variant="body2" color="primary" sx={{ fontWeight: 600 }}>
                                        {item.creditpercentage}% Credit
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
                </Grid>
                
            </Box>
            {orderObj && (
                <Box sx={{
                    mt: 3,
                    p: 2,
                    borderRadius: 2,
                    border: '1px solid #90caf9',
                    boxShadow: 2,
                }}>
                    <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                        Order Details3
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                        {orderObj.orderid === 0 ? (
                            <Typography variant="h6">
                                <b>Business Association of </b> {orderObj.title}
                            </Typography>
                        ) : (
                            <Typography variant="body2">
                                <b>Order ID:</b> {orderObj.orderid}
                            </Typography>
                        )}
                        <Box sx={{ display: 'flex', gap: 2, width: '100%', justifyContent: 'space-between'}}>
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                    Order Value:
                                </Typography>
                                <Typography variant="h6">
                                    {formatRupees(orderObj.ordervalue / 100)}
                                </Typography>
                            </Box>
                            <Box>
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                    Order Date:
                                </Typography>
                                <Typography variant="h6">
                                    {orderObj.orderdate ? new Date(orderObj.orderdate).toLocaleDateString() : ''}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )}
        </Box>
    );
}